import { call, take, put, takeLatest } from 'redux-saga/effects'

import {
  login as loginService,
  getUserApplications as getUserApplicationsService
} from '@galo-monitor/services/apis/galoMonitorApi/resources/session'
import {
  forgotPassword as forgotPasswordService,
  resetPassword as resetPasswordService
} from '@galo-monitor/services/apis/galoMonitorApi/resources/user'

import { ContextActions, ContextTypes } from '../context'
import { LanguageActions } from '../language'
import { AuthenticationActions, AuthenticationTypes } from './duckAuthentication'

function* login({ email, password, onSuccess = () => {}, onError = () => {} }) {
  try {
    const { data } = yield call(loginService, {
      email,
      password
    })

    const { token: accessToken, user } = data

    yield put(AuthenticationActions.setUser(user))

    yield put(AuthenticationActions.refreshTokenSuccess(
      `Bearer ${ accessToken }`
    ))

    if (user.isAdmin) {
      yield put(ContextActions.loadContexts())
      yield take(ContextTypes.LOAD_CONTEXTS_SUCCESS)
    }

    yield put(AuthenticationActions.loginSuccess())

    yield put(LanguageActions.changeLanguage(user.language.split('-')[0]))

    yield call(onSuccess)
  } catch (err) {
    yield put(AuthenticationActions.authenticationError(err.message))
    yield call(onError, err)
  }
}

function* forgotPassword({ email, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(forgotPasswordService, { email })
    yield call(onSuccess)
  } catch (err) {
    yield put(AuthenticationActions.authenticationError(err.message))
    yield call(onError, err)
  }
}

function* resetPassword({ resetBody, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(resetPasswordService, resetBody)
    yield call(onSuccess)
  } catch (err) {
    yield put(AuthenticationActions.authenticationError(err.message))
    yield call(onError, err)
  }
}

function* loadUserApplications() {
  try {

    const { data: userApplications } = yield call(getUserApplicationsService)

    yield put(AuthenticationActions.loadUserApplicationsSuccess(userApplications))
  } catch (err) {
    yield put(AuthenticationActions.authenticationError(err.message))
  }
}

export default [
  takeLatest(AuthenticationTypes.LOGIN, login),
  takeLatest(AuthenticationTypes.LOAD_USER_APPLICATIONS, loadUserApplications),
  takeLatest(AuthenticationTypes.FORGOT_PASSWORD, forgotPassword),
  takeLatest(AuthenticationTypes.RESET_PASSWORD, resetPassword)
]
